import * as React from 'react';
import { ArticleHeading5, ArticleParagraph2 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface IPriceNotificatorProps {
  title?: React.ReactChild;
  content?: React.ReactChild;
  actionText?: React.ReactChild;
  onActionClick: React.MouseEventHandler | null;
}

export const PriceNotificator: React.FC<IPriceNotificatorProps> = props => {
  const { title, content, actionText, onActionClick } = props;

  return (
    <div className={styles['content']}>
      <div>
        {title && (
          <div className={styles['title']}>
            <ArticleHeading5 color="text-inverted-default">{title}</ArticleHeading5>
          </div>
        )}
        <ArticleParagraph2 color="text-inverted-default">{content}</ArticleParagraph2>
      </div>
      {actionText && onActionClick && (
        <button onClick={onActionClick} className={styles['action']}>
          {actionText}
        </button>
      )}
    </div>
  );
};
